import React from 'react';
import classNames from 'classnames';
import proptypes from 'prop-types';
const { array, bool, string } = proptypes;
import { getPriceRange } from '../CollectionHelpers';

export const PriceRange = ({ products, numberOfProduct, centered, priceFloat }) => {
  const { min, max } = getPriceRange({ products });
  if (!min || !max) return null;
  const priceMessageClasses = classNames(
    'price__message',
    { 'collections__price-range--centered': centered }
  );
  const priceRangeClasses = classNames(
    'collections__price-range',
    { 'collections__price-range--centered': centered }
  );
  const priceRangeFloat = classNames(
    { 'grouped-view-collection__floating': priceFloat, 'collections__price-range--floating': !priceFloat }
  );

  return (
    <>
      {numberOfProduct && (
        <span className={priceMessageClasses}>{numberOfProduct} Products ranging from</span>
      )}
      <div className={priceRangeClasses}>
        <span className={priceRangeFloat}>
          $
        </span>
        {min?.split('.')[0]}
        <span className={priceRangeFloat}>
          {min?.split('.')[1]}
        </span>
      &nbsp;–&nbsp;
        <span className={priceRangeFloat}>
          $
        </span>
        {max?.split('.')[0]}
        <span className={priceRangeFloat}>
          {max?.split('.')[1]}
        </span>
      </div>
    </>
  );
};

PriceRange.displayName = 'PriceRange';

PriceRange.propTypes = {
  products: array.isRequired, // eslint-disable-line
  numberOfProduct: string,
  centered: bool,
  priceFloat: bool
};

PriceRange.defaultProps = {
  numberOfProduct: null,
  centered: false,
  priceFloat: false
};
